import React from 'react';
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import logo from '../assets/logo.png';

const EMAIL_USER = 'enquiries';
const EMAIL_DOMAIN = 'aftseniorassistedservices.co.uk';
const EMAIL = EMAIL_USER + '@' + EMAIL_DOMAIN;

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">

          <div className="space-y-4">
            <button onClick={() => scrollToSection('home')} className="flex items-center">
              <img src={logo} alt="AFT Senior Assisted Services" className="h-16 w-auto object-contain" />
            </button>
            <p className="text-slate-400 leading-relaxed">
              Compassionate home support services helping older adults maintain their independence and quality of life.
            </p>
            <div className="flex space-x-4 pt-4">
              <a href="https://www.facebook.com/share/1DhGVMbZoM/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/aftseniorassistedservices/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="hover:text-teal-400 transition-colors">Home</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="hover:text-teal-400 transition-colors">About Us</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-teal-400 transition-colors">Services</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('how-it-works')} className="hover:text-teal-400 transition-colors">How It Works</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-teal-400 transition-colors">Contact</button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4">Our Services</h3>
            <ul className="space-y-3">
              <li className="hover:text-teal-400 transition-colors">Welfare Checks</li>
              <li className="hover:text-teal-400 transition-colors">Companionship Visits</li>
              <li className="hover:text-teal-400 transition-colors">Medication Reminders</li>
              <li className="hover:text-teal-400 transition-colors">Shopping Assistance</li>
              <li className="hover:text-teal-400 transition-colors">Transport Support</li>
              <li className="hover:text-teal-400 transition-colors">Hospital Discharge</li>
              <li className="hover:text-teal-400 transition-colors">Home Cleaning</li>
              <li className="hover:text-teal-400 transition-colors">Pet Care</li>
              <li className="hover:text-teal-400 transition-colors">Social Visits & Community Support</li>
              <li className="hover:text-teal-400 transition-colors">Technology & Digital Support</li>
              <li className="hover:text-teal-400 transition-colors">Home Safety & Organisation Support</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-teal-400 mt-0.5 flex-shrink-0" />
                <a href="tel:07475473449" className="hover:text-teal-400 transition-colors">07475 473 449</a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-teal-400 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${EMAIL}`} className="hover:text-teal-400 transition-colors">{EMAIL}</a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-teal-400 mt-0.5 flex-shrink-0" />
                <div>
                  <span className="block">Level One, Basecamp Liverpool</span>
                  <span className="block">49 Jamaica Street</span>
                  <span className="block">Liverpool, L1 0AH</span>
                  <span className="block">United Kingdom</span>
                  <span className="block mt-2 text-slate-500 text-sm">
                    Service Area: Liverpool, Wirral, Sefton, Knowsley, St Helens, Chester, and Ellesmere Port.
                  </span>
                </div>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} AFT Senior Assisted Services. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="hover:text-teal-400 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-teal-400 transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-teal-400 transition-colors">Cookie Policy</a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;